import { styled } from 'styled-components';

export const StyledCompanyList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
